var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { linkedShape } from '../package.js';
import { irlcg } from '../ontologies/irlcg.js';
import { Server } from 'lincd-server-utils/utils/Server';
import { Answer } from 'lincd-schema/shapes/Answer';
let Resource = class Resource extends Answer {
    static loadById(id) {
        return Server.call(this, 'loadById', id);
    }
    static getResources() {
        return Server.call(this, 'getResources');
    }
};
/**
 * indicates that instances of this shape need to have this rdf.type
 */
Resource.targetClass = irlcg.Resource;
Resource = __decorate([
    linkedShape({
        description: 'Educational content that players can read to learn about the game. Represents learning materials with answer properties and content relationships. (material, guide, content)',
    })
], Resource);
export { Resource };
//# sourceMappingURL=Resource.js.map